import algoliasearch, { type SearchIndex } from 'algoliasearch'
import { defineNuxtPlugin, useRequestHeaders, useRuntimeConfig } from '#imports'

export default defineNuxtPlugin(() => {
  const options: { headers?: Record<string, string> } = {}
  if (import.meta.server) {
    const headers = useRequestHeaders()
    // Hydratation errors on local
    if (
      headers['x-forwarded-for'] &&
      !['::ffff:127.0.0.1', '::1', '127.0.0.1'].includes(headers['x-forwarded-for'])
    ) {
      options.headers = {
        'X-Forwarded-For': headers['x-forwarded-for'].split(', ')[0],
      }
    }
  }
  const config = useRuntimeConfig()

  const algoliaIndexNames = {
    missionsIndex: config.public.algolia.missionsIndex,
    missionsReplicaCreneauxIndex: config.public.algolia.missionsReplicaCreneauxIndex,
    organisationsIndex: config.public.algolia.organisationsIndex,
    termsIndex: config.public.algolia.termsIndex,
    postsIndex: config.public.algolia.postsIndex,
  }
  type algoliaIndexKeys = keyof typeof algoliaIndexNames

  const client = algoliasearch(
    config.public.algolia.appId,
    config.public.algolia.searchKey,
    options,
  )
  const searchIndexes = Object.entries(algoliaIndexNames).reduce((acc, [key, indexName]) => {
    acc[key as algoliaIndexKeys] = client.initIndex(indexName)
    return acc
  }, {} as Record<algoliaIndexKeys, SearchIndex>)

  return {
    provide: {
      algolia: {
        multipleQueries: client.multipleQueries,
        algoliaIndexNames,
        ...searchIndexes,
      },
    },
  }
})
